/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @type {string} Applicants action types.
 */

export const SET_LOADING = '[RECRUITER_APPLICANTS] SET_LOADING';
export const SET_ALL_APPLICANTS_LIST = '[RECRUITER_APPLICANTS] SET_ALL_APPLICANTS_LIST';
export const APPEND_ALL_APPLICANTS_LIST = '[RECRUITER_APPLICANTS] APPEND_ALL_APPLICANTS_LIST';
export const SET_ALL_APPLICANTS_LIST_META = '[RECRUITER_APPLICANTS] SET_ALL_APPLICANTS_LIST_META';
export const SET_SHORTLISTED_APPLICANTS_LIST = '[RECRUITER_APPLICANTS] SET_SHORTLISTED_APPLICANTS_LIST';
export const APPEND_SHORTLISTED_APPLICANTS_LIST = '[RECRUITER_APPLICANTS] APPEND_SHORTLISTED_APPLICANTS_LIST';
export const SET_SHORTLISTED_APPLICANTS_LIST_META = '[RECRUITER_APPLICANTS] SET_SHORTLISTED_APPLICANTS_LIST_META';
export const SET_FINAL_APPLICANTS_LIST = '[RECRUITER_APPLICANTS] SET_FINAL_APPLICANTS_LIST';
export const APPEND_FINAL_APPLICANTS_LIST = '[RECRUITER_APPLICANTS] APPEND_FINAL_APPLICANTS_LIST';
export const SET_FINAL_APPLICANTS_LIST_META = '[RECRUITER_APPLICANTS] SET_FINAL_APPLICANTS_LIST_META';

export const SET_SELECTED_APPLICANTS = '[RECRUITER_APPLICANTS] SET_SELECTED_APPLICANTS';
export const SET_IS_SELECT_MODE = '[RECRUITER_APPLICANTS] SET_IS_SELECT_MODE';
export const SET_LIST_TYPE = '[RECRUITER_APPLICANTS] SET_LIST_TYPE';

